import React, { useContext, useState } from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import LanguageContext from "../LanguageContext";
import messages from "../services/messages";
import UserService from "../services/UserService";
import firebase from "../firebase";

const styles = (theme) => ({
  image: {
    margin: "8px 16px",
  },
  logo: {
    height: "45px",
  },
});

function SelectLanguage(props) {
  const { onClose, selectedValue, open, languages, changeUserLanguage } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value, changeUserLanguage) => {
    onClose(value);
    changeUserLanguage(value);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="gold-service-language"
      open={open}
      fullWidth
      maxWidth={false}
    >
      <DialogTitle id="gold-service-language" style={{ textAlign: "center" }}>
        Select language
      </DialogTitle>
      <List>
        {languages &&
          languages.length > 0 &&
          languages.map((language) => (
            <ListItem
              button
              onClick={() => handleListItemClick(language, changeUserLanguage)}
              key={language.name_en}
            >
              <ListItemText primary={language.name_vernacular} />
              <ListItemIcon style={{ marginLeft: "32px" }}>
                <ArrowForwardIcon />
              </ListItemIcon>
            </ListItem>
          ))}
      </List>
    </Dialog>
  );
}

function BottomBar(props) {
  const { classes } = props;
  const language = useContext(LanguageContext);
  const languages = props.languages;
  const { mobile } = UserService.getUserInfo();
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(language);

  const handleClose = (value) => {
    setOpen(false);
    setSelectedValue(value);
  };

  const logEvent = (element_name) => {
    let event_properties = {
      element_name,
      page_name: window.location.pathname,
      user_source: props.userSource,
    };
    if (mobile) {
      event_properties.mobile = mobile;
    }
    firebase.analytics().logEvent("footer_element_clicked", event_properties);
  };

  return (
    <LanguageContext.Provider value={selectedValue}>
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <div style={{ backgroundColor: "#f1f1f1" }}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                <img
                  src={"../../icons/logo.svg"}
                  alt="AGROSTAR"
                  className={classes.logo}
                  style={{ marginTop: "40px" }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} md={8}>
                <List component="nav" aria-label="secondary mailbox folders">
                  <ListItem
                    button
                    component="a"
                    href="https://www.corporate.agrostar.in/"
                    onClick={() => logEvent("about_agrostar")}
                  >
                    <ListItemText
                      primary={messages["footer.agrostar"][language]}
                    />
                    <ListItemIcon>
                      <ArrowForwardIcon style={{ marginLeft: "16px" }} />
                    </ListItemIcon>
                  </ListItem>
                  <Divider />

                  {/* <ListItem button component="a" href="https://agrostar.in">
                <ListItemText
                  primary={messages["footer.agrostarGold"][language]}
                />
                <ListItemIcon>
                  <ArrowForwardIcon style={{ marginLeft: "16px" }} />
                </ListItemIcon>
              </ListItem>
              <Divider /> */}

                  <ListItem
                    button
                    component="a"
                    href={messages["footer.tncLinks"][language]}
                    onClick={() => logEvent("terms_and_conditions")}
                  >
                    <ListItemText
                      primary={messages["footer.tearmsAndCondtions"][language]}
                    />
                    <ListItemIcon>
                      <ArrowForwardIcon style={{ marginLeft: "16px" }} />
                    </ListItemIcon>
                  </ListItem>
                  <Divider />

                  <ListItem
                    button
                    component="a"
                    href={`tel:${messages["footer.supportNumber"][language]}`}
                    onClick={() => logEvent("call")}
                  >
                    <ListItemText primary={messages["footer.call"][language]} />
                    <ListItemIcon>
                      <ArrowForwardIcon style={{ marginLeft: "16px" }} />
                    </ListItemIcon>
                  </ListItem>
                  <Divider />

                  <ListItem
                    button
                    onClick={() => {
                      setOpen(true);
                      logEvent("language_change");
                    }}
                  >
                    <ListItemText
                      primary={messages["footer.language"][language]}
                    />
                    <ListItemIcon>
                      <ArrowForwardIcon style={{ marginLeft: "16px" }} />
                    </ListItemIcon>
                  </ListItem>

                  <Divider />
                </List>
              </Grid>
            </Grid>
          </div>
          <Grid
            container
            direction="column"
            justifyContent="space-evenly"
            alignItems="center"
            style={{
              backgroundImage: `url(../../icons/footer.png)`,
              backgroundColor: "#f1f1f1",
              height: "185px",
            }}
          >
            <Grid item>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Grid item className={classes.image}>
                  <img
                    src="../../icons/facebook.svg"
                    alt="facebook"
                    onClick={() =>
                      window.open("https://www.facebook.com/AgroStar.India/")
                    }
                    style={{ cursor: "pointer" }}
                  />
                </Grid>
                <Grid item className={classes.image}>
                  <img
                    src="../../icons/youtube.svg"
                    alt="youtube"
                    onClick={() =>
                      window.open(
                        "https://www.youtube.com/channel/UCnEo71tCmqMQyS0ZoP6P4gg"
                      )
                    }
                    style={{ cursor: "pointer" }}
                  />
                </Grid>
                <Grid item className={classes.image}>
                  <img
                    src="../../icons/instagram.svg"
                    alt="instagram"
                    onClick={() =>
                      window.open(
                        "https://www.instagram.com/agrostar_in/?hl=en"
                      )
                    }
                    style={{ cursor: "pointer" }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="caption">
                © AgroStar 2021 | All rights reserved
              </Typography>
            </Grid>
          </Grid>

          <SelectLanguage
            selectedValue={selectedValue}
            open={open}
            onClose={handleClose}
            languages={languages}
            changeUserLanguage={props.changeUserLanguage}
            userSource={props?.userSource}
          />
        </Grid>
      </Grid>
    </LanguageContext.Provider>
  );
}

BottomBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BottomBar);
